import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid2 as Grid,
  Card,
  CardContent,
  Divider,
  Paper,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const ViewCompany = ({ setpagestatus, data, AccessData }) => {
  const handleedit = () => {
    setpagestatus({
      edit: true,
      view: false,
      add: false,
    });
  };
  return (
    <Box sx={{ maxWidth: 1000, mx: "auto", p: 4 }}>
      {/* Section 1: Company Information */}

      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Grid
          size={{ xs: 12, md: 12, lg: 12 }}
          container
          spacing={1}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          {AccessData &&
            Array.isArray(AccessData) &&
            AccessData.some(
              (item) => item.component === "EditCompany" && item.can_access
            ) && (
              <IconButton onClick={handleedit}>
                <EditIcon />
              </IconButton>
            )}
        </Grid>
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            display: "flex",
            justifyContent: "center",
            margin: 1,
            color: "#0c86ec",
          }}
        >
          {data?.companyName}
        </Typography>
        <Grid container spacing={2} size={{ xs: 12, md: 12, lg: 12 }}>
          <Grid
            container
            spacing={2}
            size={{ xs: 6, md: 6, lg: 6 }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingLeft: 4,
            }}
          >
            <Typography
              variant="h5"
              fontWeight={"bold"}
              gutterBottom
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                margin: 0,
                color: "#004d85",
                fontWeight: 400,
              }}
            >
              Location
            </Typography>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                Address 1:
              </span>{" "}
              <span style={{ fontSize: "16px" }}>{data.address1}</span>
            </Grid>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                Address 2:
              </span>{" "}
              <span style={{ fontSize: "16px" }}>{data.address2}</span>
            </Grid>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                City:
              </span>{" "}
              <span style={{ fontSize: "16px" }}>{data.city}</span>
            </Grid>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                State:
              </span>{" "}
              <span style={{ fontSize: "16px" }}>{data.state}</span>
            </Grid>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                Country:
              </span>{" "}
              <span style={{ fontSize: "16px" }}>{data.country}</span>
            </Grid>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                Pincode:
              </span>{" "}
              <span style={{ fontSize: "16px" }}>{data.pincode}</span>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            size={{ xs: 6, md: 6, lg: 6 }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              alignItems: "center",
              paddingLeft: 4,
            }}
          >
            {/* Section 2: Business Details */}
            <Typography
              variant="h5"
              color="primary"
              gutterBottom
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                margin: 0,
                color: "#004d85",
              }}
            >
              Business Details
            </Typography>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                Incorporate Date
              </span>{" "}
              <span style={{ fontSize: "16px" }}>
                {data?.incorporationDate}
              </span>
            </Grid>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                Financial:
              </span>{" "}
              <span style={{ fontSize: "16px" }}>{data?.finacial}</span>
            </Grid>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                Ownershiptype:
              </span>{" "}
              <span style={{ fontSize: "16px" }}>{data.ownershipType}</span>
            </Grid>

            {/* Section 3: Registration Information */}
            <Typography
              variant="h5"
              gutterBottom
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                margin: 0,
                color: "#004d85",
              }}
            >
              Registration Information
            </Typography>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>GST:</span>{" "}
              <span style={{ fontSize: "16px" }}>{data.gstNumber}</span>
            </Grid>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                CIN :
              </span>{" "}
              <span style={{ fontSize: "16px" }}>{data.cinNumber}</span>
            </Grid>
            <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ margin: 0 }}>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                IFSC:
              </span>{" "}
              <span style={{ fontSize: "16px" }}>{data.ifscCode}</span>
            </Grid>
          </Grid>
        </Grid>

        {/* Section 4: Contact Info */}

        <Typography
          variant="h5"
          gutterBottom
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            width: "100%",
            marginLeft: 3,
            color: "#004d85",
          }}
        >
          Contact Info
        </Typography>
        {data.contactInfo.map((contact, index) => (
          <Grid
            size={{ xs: 12, md: 12, lg: 12 }}
            container
            spacing={1}
            sx={{ justifyContent: "center" }}
          >
            <Card
              key={index}
              variant="outlined"
              sx={{ mb: 2, boxShadow: 3, width: "50%" }}
            >
              <CardContent>
                <Grid
                  container
                  spacing={1}
                  size={{ xs: 12, md: 12, lg: 12 }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Grid
                    size={{ xs: 12, md: 12, lg: 12 }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{ width: 130, fontWeight: "bold", fontSize: "16px" }}
                    >
                      Name:
                    </Box>
                    <Box sx={{ width: 250, fontSize: "16px" }}>
                      {contact.salutation} {contact.name}
                    </Box>
                  </Grid>
                  <Grid
                    size={{ xs: 12, md: 12, lg: 12 }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{ width: 130, fontWeight: "bold", fontSize: "16px" }}
                    >
                      Designation:
                    </Box>
                    <Box sx={{ width: 250, fontSize: "16px" }}>
                      {contact.designation}
                    </Box>
                  </Grid>
                  <Grid
                    size={{ xs: 12, md: 12, lg: 12 }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{ width: 130, fontWeight: "bold", fontSize: "16px" }}
                    >
                      Phone:
                    </Box>
                    <Box sx={{ width: 250, fontSize: "16px" }}>
                      {contact.phoneNumber}
                    </Box>
                  </Grid>
                  <Grid
                    size={{ xs: 12, md: 12, lg: 12 }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{ width: 130, fontWeight: "bold", fontSize: "16px" }}
                    >
                      Email:
                    </Box>
                    <Box sx={{ width: 250, fontSize: "16px" }}>
                      {contact.email}
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Paper>
    </Box>
  );
};

export default ViewCompany;
